import type {GetLottieAnimationFn} from '../../../uikit/LottieView/types';

import {lottieColorify} from '../../../uikit/LottieView/colorify';
import animationJson from './animation.json';

const colorifyLayers = [
  'bckg 2',
  'stroke',
  'star',
  'star 1',
  'star 2',
  'star 3',
  'star 4',
  'star stroke',
  'star stroke 1',
  'star stroke 2',
  'star stroke 3',
  'star stroke 4',
];

export const getSessionRateAnimation: GetLottieAnimationFn = (
  color: string,
) => {
  return lottieColorify({
    color,
    layers: colorifyLayers,
    source: animationJson,
  });
};
